import React, { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Compact opening countdown pill for the in-app header
const MiniCountdown = () => {
  const [cfg, setCfg] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const fetchCfg = () => {
      fetch(`${BACKEND_URL}/api/gate/countdown`)
        .then(r => r.ok ? r.json() : null)
        .then(d => setCfg(d?.enabled && d?.target_utc ? d : null))
        .catch(() => {});
    };
    fetchCfg();
    const refresh = setInterval(fetchCfg, 5 * 60 * 1000);
    return () => clearInterval(refresh);
  }, []);

  useEffect(() => {
    if (!cfg) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [cfg]);

  if (!cfg) return null;

  const diff = new Date(cfg.target_utc).getTime() - now;
  const live = diff <= 0;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const pad = (n) => String(n).padStart(2, '0');

  return (
    <div
      data-testid="mini-countdown"
      title={live ? "We're live!" : `${cfg.title} — ${cfg.event_date} ${cfg.event_time} ${cfg.tz}`}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '8px',
        padding: '5px 14px', borderRadius: '999px',
        background: live ? 'rgba(0,255,136,0.10)' : 'rgba(0,0,0,0.35)',
        border: `1px solid ${live ? 'rgba(0,255,136,0.5)' : 'rgba(0,255,255,0.35)'}`,
        boxShadow: live ? '0 0 14px rgba(0,255,136,0.25)' : '0 0 14px rgba(0,255,255,0.12)',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{
        fontSize: '10px', fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase',
        background: 'linear-gradient(90deg, #00ffff, #ff00ff)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      }}>
        ⚡ {cfg.title}
      </span>
      {live ? (
        <span style={{ fontSize: '11px', fontWeight: 800, color: '#00ff88' }} data-testid="mini-countdown-live">
          🎉 WE'RE LIVE!
        </span>
      ) : (
        <span style={{ fontSize: '12px', fontWeight: 700, color: '#e2f8ff', fontVariantNumeric: 'tabular-nums' }} data-testid="mini-countdown-timer">
          {d > 0 && `${d}d `}{pad(h)}h {pad(m)}m {pad(s)}s
        </span>
      )}
    </div>
  );
};

export default MiniCountdown;
